import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getDepartments, createDepartment, resetDepartment, resetNewlycreatedDepartmentId } from "../store/actions/departmentActions";
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";

import moment from 'moment';
import LOADER from "../assets/images/loader.svg";
import { useHistory } from 'react-router-dom';
import { LuPlus } from "react-icons/lu";



import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';



import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";

import Overlay from "../components/Departments/Overlay";
//import DepartmentTable from "../components/Departments/DepartmentTable";
import DepartmentCard from "../components/Departments/DepartmentCard";

function Departments(props) {

    const { token, getDepartmentsFN, departments, department_id, resetDepartmentFN, createDepartmentFN, department_dashboard_data, newlycreatedDepartmentId, resetNewlycreatedDepartmentIdFN } = props;

    const history = useHistory();

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);

    const [currentDepartment, setCurrentDepartment] = useState(null);

    const closeCreation = () => {
        getDepartmentsFN();
        resetDepartmentFN();
        resetNewlycreatedDepartmentIdFN();
        setIsPopupOpen(false);

    }

    useEffect(() => {
        getDepartmentsFN();
    }, []);

    useEffect(() => {
       //alert(department_id);
       if (department_id) {
        let department = departments && departments.find(department => department.department_id === department_id);

        //////console.log(department_id, department);
        setCurrentDepartment(department);
        setIsPopupOpen(true);
    }
    }, [department_id]);


    useEffect(() => {
        if (department_dashboard_data) {
            history.push({ pathname: "/units", state: { departmentfromredirect: department_dashboard_data } });
        }
    }, [department_dashboard_data]);

    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
    }, [newlycreatedDepartmentId]);

    return token  ? (
            <>
                <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
                    <div className="h-full w-full mt-4"> {/* Remove overflow-x-auto to prevent scrolling */}
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {departments?.map((department) => (
                            <DepartmentCard
                                key={department.department_id}
                                department={department}
                                // onEdit={() => ////console.log("Edit", department)}
                                // onStats={() => ////console.log("Stats", department)}
                                // onDelete={() => ////console.log("Delete", department)}
                            />
                        ))}
                    </div>
                        <div style={{ height: "20px" }}></div>

                    </div>
                </div>
           

            <Popup
                open={isPopupOpen}
                onClose={closeCreation}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <Overlay close={closeCreation} department={currentDepartment} edit={true} />
            </Popup>
        </>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    return {

        token: state.auth.token,
        departments: state.department.departments,
        department_id: state.department.department_id,
        department_dashboard_data: state.department.department_dashboard_data,
        newlycreatedDepartmentId: state.department.newlycreatedDepartmentId



    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        getDepartmentsFN: () => dispatch(getDepartments()),
        resetDepartmentFN: () => dispatch(resetDepartment()),
        createDepartmentFN: () => dispatch(createDepartment()),
        resetNewlycreatedDepartmentIdFN: () => dispatch(resetNewlycreatedDepartmentId())
    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Departments);

//   return token  ? (
//         <div className="flex flex-col w-full h-screen overflow-hidden">
//             <TopBar className="fixed top-0 left-0 right-0 z-10" />
//             <div className="flex flex-row w-full h-full overflow-hidden"> {/* Prevent horizontal scrolling */}
//                 <Sidebar className="fixed top-0 left-0 h-full pt-[64px] z-0" /> {/* Adjust the top to match TopBar height */}
//                 <div className="flex flex-col w-full p-4 overflow-auto"> {/* Adjust the margin-left to match Sidebar width */}
//                     <div className="flex flex-row">
//                         <button
//                             className="flex items-center justify-center gap-2 pt-2 pb-2 h-10 text-l bg-[#F8F8F8] text-black transition duration-200 rounded-[5px] px-5 hover:bg-opacity-70 shadow-md border border-gray-300 hover:shadow-lg hover:bg-[#F0F0F2]"
//                             onClick={() => createDepartmentFN()}
//                         >
//                             <LuPlus className="ml-[-10px] w-5 h-5" />
//                             <span>Add Department</span>
//                         </button>
//                     </div>
//                     <div className="h-full w-full mt-4"> {/* Remove overflow-x-auto to prevent scrolling */}
//                     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//                         {departments?.map((department) => (
//                             <DepartmentCard
//                                 key={department.department_id}
//                                 department={department}
//                                 // onEdit={() => ////console.log("Edit", department)}
//                                 // onStats={() => ////console.log("Stats", department)}
//                                 // onDelete={() => ////console.log("Delete", department)}
//                             />
//                         ))}
//                     </div>
//                         <div style={{ height: "20px" }}></div>

//                     </div>
//                 </div>
//             </div>

//             <Popup
//                 open={isPopupOpen}
//                 onClose={closeCreation}
//                 contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
//             >
//                 <Overlay close={closeCreation} department={currentDepartment} edit={true} />
//             </Popup>
//         </div>
//     ) : <Redirect to="/login" />;